import { CurrencyType } from './../entities/currency-type';
import { DocumentType } from './../entities/documentType';
import { Employee } from 'app/core/entities/employee';
import { IncomeMain } from 'app/core/entities/incomeMain';
import { Injectable, Injector } from '@angular/core'; 
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable'; 
import { ExecutingUnit } from '../entities/executingUnit';
import { FiscalYear } from '../entities/fiscalYear';
import { tap, map, catchError } from 'rxjs/operators'; 
import { Mhelpdesk } from '../entities/mhelpdesk';
import { Vendor } from '../entities/vendor';
import { Register } from '../entities/register';
import { PaymentType } from '../entities/paymentType';
import * as FileSaver from 'file-saver';
import { ParamsIncomeDTO } from '../model/params-Income-dto';
import { PagosCabDet } from '../model/pagos-cab-det';

interface ExtraSearchFields {
    fiscalYear?: FiscalYear
    executingUnit?: ExecutingUnit, 
    register?: Register,
    startMonth?:Mhelpdesk  , 
    endMonth?:Mhelpdesk  ,  

    startDate ?:  Date, 
    endDate ?:  Date, 
    paymentType?: PaymentType,
    paymentMethod?: Mhelpdesk,
    currencyType?: CurrencyType,
    incomeCodeStart?: string,
    incomeCodeEnd?: string ,
    documentType?: DocumentType ,
    identifier? : Mhelpdesk,
    vendor?: Vendor  ,
    persona?: string , 
    code?: string,
    comment?:string
}

@Injectable()
export class IncomeMainService extends BaseCrudService<IncomeMain> {

  public uri = '/api/incomeMain/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance IncomeMainService');
  }

  buildSentence(entity?: IncomeMain, event?: LazyLoadEvent , extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity  || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.register ?
          `register.id${QueryOperator.Equal}${extraSearchFields.register.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startMonth && extraSearchFields.endMonth ?
          // tslint:disable-next-line:max-line-length
          `month.code${QueryOperator.Between}${extraSearchFields.startMonth.code}${QueryOperator.Slash}${extraSearchFields.endMonth.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDate && extraSearchFields.endDate ?
          // tslint:disable-next-line:max-line-length
          `documentDate${QueryOperator.Between}${extraSearchFields.startDate.toISOString()}${QueryOperator.Slash}${extraSearchFields.endDate.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        extraSearchFields && extraSearchFields.paymentMethod  ? 
          `paymentMethod.id${QueryOperator.Equal}${extraSearchFields.paymentMethod.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        extraSearchFields && extraSearchFields.paymentType  ? 
          `paymentType.id${QueryOperator.Equal}${extraSearchFields.paymentType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.paymentType  ? 
          `paymentType.id${QueryOperator.Equal}${extraSearchFields.paymentType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.currencyType  ? 
          `currencyType.id${QueryOperator.Equal}${extraSearchFields.currencyType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        extraSearchFields && extraSearchFields.incomeCodeStart && extraSearchFields.incomeCodeEnd ?
          // tslint:disable-next-line:max-line-length
          `code${QueryOperator.Between}${extraSearchFields.incomeCodeStart}${QueryOperator.Slash}${extraSearchFields.incomeCodeEnd}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.documentType  ? 
          `documentType.id${QueryOperator.Equal}${extraSearchFields.documentType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        extraSearchFields && extraSearchFields.identifier  ? 
          `identifier.id${QueryOperator.Equal}${extraSearchFields.identifier.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 

       query = query.concat(
        extraSearchFields && extraSearchFields.vendor  ? 
          `vendor.id${QueryOperator.Equal}${extraSearchFields.vendor.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      
      query = query.concat(
        entity && entity.code  ? 
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
       query = query.concat(
        entity && entity.batchNumber  ? 
          `batchNumber${QueryOperator.Contain}${entity.batchNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity && entity.documentNumber  ? 
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.total  ? 
          `total${QueryOperator.Equal}${entity.total}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity && entity.balance  ? 
          `balance${QueryOperator.Equal}${entity.balance}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity && entity.caseFileNumber  ? 
          `caseFileNumber${QueryOperator.Contain}${entity.caseFileNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity && entity.estimateNumber  ? 
          `estimateNumber${QueryOperator.Contain}${entity.estimateNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
       
       this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    //this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }
 
  search2(entity?: IncomeMain, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<IncomeMain>> {
  //console.log("en el search2 ..... ");
  //console.log("entity : " , entity);
  //console.log("event : " , event);
  //console.log("extraSearchFields : " , extraSearchFields);

    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<IncomeMain>>(url, { params: this.buildSentence(entity, event, extraSearchFields) })
        .pipe(
            tap(response => {
                if (response.numberOfElements > 0) {
                    response.content.forEach((value) => {
                        // debugger;
                        this.addLogicToSearch(value);
                        this.convertToDate(value);
                    })
                }
               //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
}

searchToCreditNote(entity?: IncomeMain,option?: number,event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<IncomeMain>> {
 //console.log("en el search2 ..... ");
 //console.log("entity : " , entity);
 //console.log("event : " , event);
 //console.log("extraSearchFields : " , extraSearchFields);
  let params ;
  params = this.buildSentence(entity, event, extraSearchFields)
  params = params.set('option', option);
      const url = this.rutaServidor + this.uri + 'searchToCreditNote';
      //this.spinnerService.showAll();
      return this.httpClient.get<ResponsePageable<IncomeMain>>(url, { params })
          .pipe(
              tap(response => {
                  if (response.numberOfElements > 0) {
                      response.content.forEach((value) => {
                          // debugger;
                          this.addLogicToSearch(value);
                          this.convertToDate(value);
                      })
                  }
                 //console.log(response);
                  this.spinnerService.hideAll();
                  return response;
              })
          );
  }
 
  
  setTotalMonto(entity?: IncomeMain ): Observable<ResponsePageable<IncomeMain>> { 
        //console.log("LLAMANDO AL METODO SETTOTALMONTO !!!!!!");
        const url = this.rutaServidor + this.uri + 'setTotalMonto';
     
        return this.httpClient.post<ResponsePageable<IncomeMain>>(url,entity);
          
    }
     
 


    updateFlgReturn(id:  number , flgReturn : Boolean ): Observable<ResponsePageable<IncomeMain>> { 
     //console.log("updateFlgReturn ");
      const url = this.rutaServidor + this.uri + 'updateFlgReturn?id='+id+'&flgReturn='+flgReturn; 
      let params = new HttpParams;
      params = params.set('id', id.toString());
      params = params.set('flgReturn', flgReturn.toString());
     //console.log(params);
      return this.httpClient.get<ResponsePageable<IncomeMain>>(url);
    }

    getCreditIncomeMain(entity?: IncomeMain,option?: number,event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<IncomeMain>> {
     //console.log("en el search2 ..... ");
     //console.log("entity : " , entity);
     //console.log("event : " , event);
     //console.log("extraSearchFields : " , extraSearchFields);
      let params ;
      params = this.buildSentence(entity, event, extraSearchFields)
      params = params.set('option', option);
          const url = this.rutaServidor + this.uri + 'getCreditIncomeMain';
          //this.spinnerService.showAll();
          return this.httpClient.post<ResponsePageable<IncomeMain>>(url, entity)
              .pipe(
                  tap(response => {
                      if (response.numberOfElements > 0) {
                          response.content.forEach((value) => {
                              // debugger;
                              this.addLogicToSearch(value);
                              this.convertToDate(value);
                          })
                      }
                     //console.log(response);
                      this.spinnerService.hideAll();
                      return response;
                  })
              );
      }


      sendToCreateFileYaml(entity?: IncomeMain , userId? : number): Observable<ResponsePageable<IncomeMain>> { 
        let params ;  
            const url = this.rutaServidor + this.uri + 'sendToCreateFileYaml/'+userId;
            this.spinnerService.showAll();
            return this.httpClient.post<ResponsePageable<IncomeMain>>(url, entity)
                .pipe(
                    tap(response => {
                        if (response.numberOfElements > 0) {
                            response.content.forEach((value) => {
                                // debugger;
                                this.addLogicToSearch(value);
                                this.convertToDate(value);
                            })
                        }
                       //console.log(response);
                        this.spinnerService.hideAll();
                        return response;
                    })
                );
        }
 

    seeResultLog(entity?: IncomeMain , fileName? :string): Observable<any> {
        const url = this.rutaServidor + this.uri + 'seeResultLog';
        this.spinnerService.showAll();
        return this.httpClient.post(url,entity, {responseType: 'blob', observe: 'response' } )
        .pipe(
            map(res =>  {
             //console.log(res);
              this.spinnerService.hideAll();
              let bean = new Blob([res.body], { type: 'application/log'});
                    FileSaver.saveAs(bean, fileName);
                    return bean;
                }
            ),
            catchError((err, caught) => {
                let resp = 'No se encontraron registros';
                this.spinnerService.hideAll();
                if (err.status == 404)
                this.notificationService.smallBoxWarning('Ventana de Alerta!', resp);
                return new Observable<Blob>();
                }
            )
        );
    }

    //GENERATE VOUCHER !!!

    getTreeNodeIncomeGroupByDate(entity?: IncomeMain, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<any> {
    
     // getTreeNodeIncomeGroupByDate(paramsIncomeDTO?: ParamsIncomeDTO):Observable<any>{   
      const rutaServidor = localStorage.getItem('rutaServidor');
     //console.log("rutaServidor :" + rutaServidor);
      const url =  rutaServidor +  this.uri + 'getTreeNodeIncomeGroupByDate';
     //console.log("url :" + url);
      this.spinnerService.showAll();
      return this.httpClient.get(url, { params: this.buildSentence(entity, event, extraSearchFields) })
      .pipe(
        tap(response => {
            if (response.numberOfElements > 0) {
                response.content.forEach((value) => {
                    // debugger;
                    this.addLogicToSearch(value);
                    this.convertToDate(value);
                })
            }
           //console.log(response);
            this.spinnerService.hideAll();
            return response;
        })
    );
   
    //return this.httpClient.post(url,paramsIncomeDTO);
    }

    sendToGenerateVoucher(fy :number, ue :number, fecha :string ,   incomeMain?: String[]):Observable<any>{   
      const rutaServidor = localStorage.getItem('rutaServidor');
     //console.log("rutaServidor :" + rutaServidor);
      const url =  rutaServidor +  this.uri + 'sendToGenerateVoucher/'+ fy+"/"+ue + "/"+fecha;
     //console.log("url :" + url);
    return this.httpClient.post(url,incomeMain);
    }

    
    /// PROCESAR INTERFACE 

   // getDataProcessInterface(entity?: IncomeMain, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<any> {
    
      getDataProcessInterface(paramsIncomeDTO?: ParamsIncomeDTO):Observable<any>{   
       const rutaServidor = localStorage.getItem('rutaServidor');
      //console.log("rutaServidor :" + rutaServidor);
       const url =  rutaServidor +  this.uri + 'getDataProcessInterface';
      //console.log("url :" + url);
       this.spinnerService.showAll();
       return this.httpClient.post(url, paramsIncomeDTO )
       .pipe(
         tap(response => {
             if (response.numberOfElements > 0) {
                 response.content.forEach((value) => {
                     // debugger;
                     this.addLogicToSearch(value);
                     this.convertToDate(value);
                 })
             }
            //console.log(response);
             this.spinnerService.hideAll();
             return response;
         })
     );
    
     //return this.httpClient.post(url,paramsIncomeDTO);
     }


    sendToProcessInterface(lista?: PagosCabDet[]):Observable<any>{   
      const rutaServidor = localStorage.getItem('rutaServidor');
     //console.log("rutaServidor :" + rutaServidor);
      const url =  rutaServidor +  this.uri + 'sendToProcessInterface';
     //console.log("url :" + url);
     this.spinnerService.showAll();
    return this.httpClient.post(url,lista).pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
              response.content.forEach((value) => {
                  // debugger;
                  this.addLogicToSearch(value);
                  this.convertToDate(value);
              })
          }
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
      })
  );
    }


}



// WEBPACK FOOTER //
// ./src/app/core/services/income-main.service.ts